export const ChineseTranslations = {
  
}
